module.exports = __webpack_public_path__ + "static/media/gy.5e937c33.svg";